/**
 * Entry point. The stylesheet import is the migration's single-source-of-truth
 * rule: this app renders the SAME design system as site/portal — one file,
 * whichever shell serves it.
 *
 * Two shells, two identities: /admin/* mounts the staff console behind
 * /admin/me, everything else mounts the tenant shell behind /me. Staff and
 * tenants never share a guard, mirroring the API's separation.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import '../../../site/portal/assets/app.css';
import { AdminShell } from './adminShell';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { Properties } from './pages/Properties';
import { PropertyDetail } from './pages/PropertyDetail';
import { Settings } from './pages/Settings';
import { Users } from './pages/Users';
import { AdminSettings } from './pages/admin/AdminSettings';
import { AdminUsers } from './pages/admin/AdminUsers';
import { OrgDetail } from './pages/admin/OrgDetail';
import { Orgs } from './pages/admin/Orgs';
import { Staff } from './pages/admin/Staff';
import { TenantShell } from './shell';

const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    path: '/admin',
    element: <AdminShell />,
    children: [
      { index: true, element: <Orgs /> },
      { path: 'orgs/:id', element: <OrgDetail /> },
      { path: 'users', element: <AdminUsers /> },
      { path: 'staff', element: <Staff /> },
      { path: 'settings', element: <AdminSettings /> },
    ],
  },
  {
    element: <TenantShell />,
    children: [
      { path: '/', element: <Overview /> },
      { path: '/properties', element: <Properties /> },
      { path: '/properties/:id', element: <PropertyDetail /> },
      { path: '/users', element: <Users /> },
      { path: '/settings', element: <Settings /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
